import { render, staticRenderFns } from "./templates-thumbs.vue?vue&type=template&id=0c602b16&"
import script from "./templates-thumbs.vue?vue&type=script&lang=js&"
export * from "./templates-thumbs.vue?vue&type=script&lang=js&"
import style0 from "./templates-thumbs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports